export default __webpack_public_path__ + "static/media/rancho_book_header.9b303295.png";